import { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';

import { getAccounts as fetch, reset, setFilters, setPagination } from 'accounts/actions';
import { getPagination, getFilters, getNeedFetch } from 'accounts/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';

import { valueFromEvent } from 'lib/util';

class AccountsListHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
    r: PropTypes.func.isRequired,
  };

  state = {
    columnSearch: [
      // Cambiar por redux
      { key: 'key', name: this.props.t('accounts.searchEditor.key'), search: true },
      { key: 'name', name: this.props.t('accounts.searchEditor.name'), search: true },
      { key: 'description', name: this.props.t('accounts.searchEditor.description'), search: true },
    ],
  };

  handleToggleSearch = (col) => {
    let columnsNuevo = this.state.columnSearch;
    let datos = columnsNuevo.find((column) => column.key == col);
    datos.search = !datos.search;
    this.setState({ columnSearch: columnsNuevo });
    let columnsSearch = [];
    columnsNuevo.forEach((e) => {
      if (e.search) {
        columnsSearch.push(e.key);
      }
    });
    this.props.setFilters({ columnSearch: columnsSearch }); // Agregado a Redux
  };

  fetch = (filters, pagination) =>
    this.props.fetch(
      this.props.company.id,
      this.props.subcompany.id,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );

  fetchDebounced = debounce(this.fetch, 400);

  handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

  handleLimitChange = (limit) => this.props.setPagination({ limit: parseInt(limit, 10) });

  handlePageChange = (page) => this.props.setPagination({ page: parseInt(page, 10) });

  handleFiltersChange = (e) => this.props.setFilters(valueFromEvent(e));

  handleSubmit = () => this.fetch(this.props.pagination, this.props.filters);

  componentWillMount = () => this.fetch(this.props.filters, this.props.pagination);

  componentWillUnmount = () => this.props.reset();

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.needFetch && !isEqual(nextProps.pagination, this.props.pagination)) {
      this.fetch(nextProps.filters, nextProps.pagination);
    } else if (nextProps.needFetch && !isEqual(nextProps.filters, this.props.filters)) {
      this.fetchDebounced(nextProps.filters, nextProps.pagination);
    }
  };

  render = () =>
    this.props.render({
      handleOrderChange: this.handleOrderChange,
      handleLimitChange: this.handleLimitChange,
      handlePageChange: this.handlePageChange,
      handleFiltersChange: this.handleFiltersChange,
      handleSubmit: this.handleSubmit,
      handleToggleSearch: this.handleToggleSearch,
      columnSearch: this.state.columnSearch,
    });
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  filters: getFilters(state),
  pagination: getPagination(state),
  needFetch: getNeedFetch(state),
});

const mapDispatchToProps = { fetch, reset, setFilters, setPagination };

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(AccountsListHandlers);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/containers/AccountsListHandlers.js